export default "__VITE_ASSET__BVTKO6_V__"